var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .334A5.673 5.673 0 0 0 .333 6.001c0 1.345.483 2.65 1.365 3.682.1.115 2.475 2.813 3.269 3.57a1.493 1.493 0 0 0 2.067 0c.922-.88 3.174-3.462 3.273-3.575A5.666 5.666 0 0 0 11.667 6 5.673 5.673 0 0 0 6 .334Zm0 7.333a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z",
    fill: "#323232"
  })));
};

export default SvgAddress;